import axios from './axios';

// 上傳商品圖片
export function uploadProductImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/api/files/product-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
}

// 上傳商品描述富文本圖片
export function uploadProductRichtextImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/api/files/product-richtext-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
}

// 上傳首頁輪播圖
export function uploadBannerImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/api/files/banner-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
}

// 上傳文章縮圖
export function uploadArticleImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/api/files/article-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
}

// 上傳公告縮圖
export function uploadAnnouncementImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/api/files/announcement-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
}

// 上傳文章內容富文本圖片
export function uploadArticleRichtextImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/api/files/article-richtext-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
}

// 上傳公告內容富文本圖片
export function uploadAnnouncementRichtextImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/api/files/announcement-richtext-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
}

// 取得圖片網址（若透過 API 存取圖片）
export function getImageUrl(type, filename) {
    return `/api/files/image/${type}/${encodeURIComponent(filename)}`;
}
